import { Component, inject, signal } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { HttpNotificationService } from './services/http-notification.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('ce-request-flow');
  protected readonly currentRoute = signal('');
  protected readonly notifications = inject(HttpNotificationService);

  protected readonly navigationItems = [
    { label: 'Requests', id: '' },
    { label: '1 · Project Team', id: 'project-team' },
    { label: '2a · New Project', id: 'new-project' },
    { label: '2b · Existing Project', id: 'existing-project' },
    { label: '3 · Questionnaire', id: 'questionnaire' },
    { label: 'Response Page', id: 'response-page' },
    { label: 'View Request', id: 'view-request' },
  ];

  constructor(
    private router: Router,
  ) {
    this.currentRoute.set(this.normalizeRoute(this.router.url));

    this.router.events.subscribe(() => {
      this.currentRoute.set(this.normalizeRoute(this.router.url));
    });
  }

  protected navigate(item: { id: string }): void {
    if (!this.isMenuItemClickable(item)) {
      return;
    }

    this.router.navigate([item.id || '']);
  }

  protected isMenuItemClickable(item: { id: string }): boolean {
    return item.id === '';
  }

  protected visibleNavigationItems(): Array<{ label: string; id: string; active: boolean }> {
    const route = this.currentRoute();

    if (route === '' || route === 'my-ce-requests' || route === 'my-ce-requests-assigned') {
      return [{
        label: this.getHomeLabel(),
        id: '',
        active: true,
      }];
    }

    const flowOrder = this.resolveFlowOrder(route);
    const visibleIds = flowOrder.slice(0, flowOrder.indexOf(route) + 1);

    return this.navigationItems
      .filter(item => visibleIds.includes(item.id))
      .map(item => this.withActive(item.id === '' ? { ...item, label: this.getHomeLabel() } : item, route));
  }

  private getHomeLabel(): string {
    return 'Requests';
  }

  private resolveFlowOrder(route: string): string[] {
    if (route === 'existing-project') {
      return ['', 'project-team', 'existing-project'];
    }

    if (route === 'view-request') {
      return ['', 'view-request'];
    }

    if (route === 'response-page') {
      return ['', 'response-page'];
    }

    if (route === 'new-project' || route === 'questionnaire') {
      return ['', 'project-team', 'new-project', 'questionnaire', 'view-request'];
    }

    return ['', 'project-team'];
  }

  private withActive(item: { label: string; id: string }, route: string): { label: string; id: string; active: boolean } {
    return {
      ...item,
      active: item.id === route,
    };
  }

  private normalizeRoute(url: string): string {
    const path = url.split('?')[0];
    return path.split('/')[1] || '';
  }
}
